export default function canUseFloatOpacityTexture(context) {
    return Boolean(context.getExtension('OES_texture_float_linear'));
}
